import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { CraApiVariableSchema } from '../../domain/cra/CraDomains';

export type CraApiVariableActions =
  | 'SET_CRA_API_VARIABLE'
  | 'CLEAR_CRA_API_VARIABLE'
  | 'CLEAR_ALL_CRA_API_VARIABLES';

export const setCraApiVariable = (name: string, data: CraApiVariableSchema) => ({
  type: 'SET_CRA_API_VARIABLE',
  payload: { name, data },
}) as ReduxBaseAction<{ name: string; data: CraApiVariableSchema }, CraApiVariableActions>;

export const clearCraApiVariable = (name: string) => ({
  type: 'CLEAR_CRA_API_VARIABLE',
  payload: { name },
}) as ReduxBaseAction<{ name: string }, CraApiVariableActions>;

export const clearAllCraApiVariables = () => ({
  type: 'CLEAR_ALL_CRA_API_VARIABLES',
  payload: undefined,
}) as ReduxBaseAction<undefined, CraApiVariableActions>; 